<template>
    <!-- <div class="literature-body know-us"> -->
        <div id="content-sidebar" class="know-us">
            <div class="sidebar-column">
                <div class="vert-diag">
                    <h1 style="text-transform:uppercase;">
                        <span>PIP USA</span><br />KNOW US
                    </h1>
                    <div class="lines"></div><!-- lines -->
                    <div class="red-diagonals"></div>
                </div><!-- vert-diag -->
            </div><!-- sidebar-column -->

            <div class="main-wrapper">
                <h1 style="display:none;">Learn More About the Humble Beginnings of PIP</h1>

                <VueSlickCarousel v-bind="settings">
                    <div class="item" id="first-slider">
                        <figure>
                            <img src="/images/timeline/01_1984_timeline-wellson-joe.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>1984</strong>
                            <span>/</span>
                        </div>
                        <p>
                            Joe Milot, a young and ambitious accountant, and Wellson Tao, with strong roots in sourcing
                            and manufacturing, form Protective Industrial Products Inc. with an initial investment of
                            $2,000.
                        </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_1984_Image.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>1984</strong>
                            <span>/</span>
                        </div>
                        <p>Working out of a 400 square-foot space in Albany, NY, PIP® – as it quickly became known –
                            started selling cotton lisle gloves for the inspection and handling of small parts. The
                            business grew quickly as demand for work gloves grew, with more and more companies requiring
                            PPE.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_1991.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>1990s</strong>
                            <span>/</span>
                        </div>
                        <p>In the early 90s, the demand for gloves and new technologies took off. PIP® distinguished
                            itself by offering distributors great products, good prices and robust stock levels, which
                            enabled them to quickly become a favorite supplier – leading PIP® to expand its head office
                            and distribution center to 28,000 square feet. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2001.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2001</strong>
                            <span>/</span>

                        </div>
                        <p>By the early 2000s, PIP® had become a preferred supplier of work gloves to many of the newly
                            formed distributor buying groups due to their business philosophy of “We don’t say NO to our
                            customers. We find reason to say YES.” During this time, PIP® also acquired Georgia Safety
                            Group and Gloves Unlimited, Inc. which lead to the opening of an additional distribution
                            center in Memphis, TN, as well as PRI industries – a US manufacturer of specialty seamless
                            knits.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2004_ATG.JPG" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2004</strong>
                            <span>/</span>

                        </div>
                        <p>In 2004, PIP® established an exclusive sales partnership with ATG® Gloves in North America
                            and, together, they introduced the world to the MaxiFlex® G-Tek® glove, as it was known
                            then. This glove set the standard for fit, form and function that, even today, remains
                            unrivaled.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2004_PIP-Mexico.JPG" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2004</strong>
                            <span>/</span>
                        </div>
                        <p>The need for PPE continued to grow not only in the U.S. but globally. PIP® began investing in
                            operations outside of the U.S. – establishing PIP Mexico and PIP Latin America.</p>

                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/03_2004_warehouse-expansion.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2004</strong>
                            <span>/</span>

                        </div>
                        <p>Continued growth also allowed the company to expand its New York operations to 125,000 square
                            feet and its Tennessee distribution center to 90,000 square feet. The expansion of PIP's
                            operation in New York included the creation of Black Pearl Manufacturing, a dedicated
                            facility for custom packaging, PPE logo imprinting for customers and dielectric testing for
                            electrical insulated gloves.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2006.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2006</strong>
                            <span>/</span>
                        </div>
                        <p>This period marked the launch of PIP’s retail division, having acquired the Mud® and West
                            County Gardener® consumer glove brand and business, along with Brahma® work gloves. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2006.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2006</strong>
                            <span>/</span>
                        </div>
                        <p>On the industrial side, advancements in glove technologies continued to be made due to the
                            acquisition of the DSM Dyneema® license. PIP® quickly gained a leadership position as a
                            supplier of advanced coated seamless knit gloves with cut resistance.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2009_Safetygear.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2009</strong>
                            <span>/</span>

                        </div>
                        <p>By the end of the decade, PIP® was now a $100 million company thanks to the acquisition of
                            SafetyGear™ USA – a protective clothing company that enabled PIP® to expand its product
                            offering to include hand protection, protective and hi-vis garments. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2009_Europe.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2009</strong>
                            <span>/</span>

                        </div>
                        <p>PIP® established a partnership in Europe and opened an office and distribution center in
                            Italy. Altogether, these milestones were more than Joe and Wellson had ever imagined. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2011_Dupont.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2011</strong>
                            <span>/</span>

                        </div>
                        <p>The new decade marked PIP’s strong foray into the PPE market – starting with the acquisition
                            of the DuPont® Kevlar® license. Having achieved a dominant position in reusable work gloves,
                            Joe and Wellson decided to further expand within Safety by investing more deeply into PPE
                            products.</p>
                        <p>PIP® also expanded its U.S. manufacturing capabilities with the acquisition of McHenry
                            Knitting and Manufacturing which, along with PR Industries acquired in 2003, made PIP® one
                            of the largest U.S. based manufacturers of gloves and sleeves made with Kevlar®.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2011_Bouton_Vintage.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2011</strong>
                            <span>/</span>
                        </div>
                        <p>The recent acquisition of SafetyGear™ USA inspired PIP® to take the chance and purchase the
                            H.L. Bouton brand and business – an American pioneer in safety eyewear – known for
                            developing special tank goggles for the U.S. Army during World War II. ISSI Eyewear was also
                            acquired, further expanding PIP’s eye protection product offering. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/04_2011_JSPMontage-of-Guilderland-logoing.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2011</strong>
                            <span>/</span>
                        </div>
                        <p>This was also an optimal time to expand globally and seek out new partnerships. During this
                            period, PIP® entered into a partnership with U.K.-based JSP® Safety, allowing PIP® to sell a
                            line of head protection that set the standard for advanced design and features. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/05_2011_PIP-Europe-and-China.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2011</strong>
                            <span>/</span>
                        </div>
                        <p>PIP® also expanded operations in Europe, Canada and in Asia – officially establishing PIP
                            Europe, PIP Canada Ltd. and PIP Asia Pacific, whose operations expanded from Hong Kong to
                            include sales and distribution centers in China and Australia.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2015_Wellson-and-Joe.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2015</strong>
                            <span>/</span>

                        </div>
                        <p>By the middle of the decade, Wellson began to step back from the daily operations in Asia to
                            spend time mentoring the new generation of leaders and supporting Joe, who had his eyes on
                            expanding PIP® further. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2015_Safety-Works.JPG" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2016</strong>
                            <span>/</span>

                        </div>
                        <p>In 2016, PIP® doubled down on retail by purchasing Safety Works – a leading retail brand in
                            safety – from MSA. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/03_2015_Century-Glove.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2017</strong>
                            <span>/</span>
                        </div>
                        <p>Joe went on to buy Safe Industries, another U.S. manufacturer of knitted sleeves. Then, in
                            2017, Joe and Wellson – in the ultimate irony – would purchase Century Gloves, the company
                            whose actions in 1984 ignited the spark for Joe and Wellson to get together and form
                            Protective Industrial Products.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/04_2015.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2017</strong>
                            <span>/</span>
                        </div>
                        <p>By the end of 2017, PIP® had grown to be a referenced global leader in hand protection with
                            more than 300 employees, $250 million in sales and a presence in the Americas, Europe and
                            Asia Pacific.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2018_audax.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2018</strong>
                            <span>/</span>
                        </div>
                        <p>The end of the decade marked a new dawn for the company. With Wellson retiring, Joe and his
                            children along with Wellson’s children began searching for a new partner that could help
                            make PIP® a global leader in hand protection and PPE. In 2018, Audax Group became that
                            partner. It was Joe’s decision to find a partner that aligned with his philosophy of
                            customer excellence and service. For Joe, the new dawn would be about expanding to serve
                            customers better AND to make Safety better. This vision drove him to seek out companies he
                            had long respected for the technologies they developed and the customers they served.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/03_2018_Hearos.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2018</strong>
                            <span>/</span>
                        </div>
                        <p>This was followed by the acquisition of HEAROS ear plugs which included a manufacturing
                            facility with global capacity. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/04_2018_PIP_International_Meeting.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2018</strong>
                            <span>/</span>
                        </div>
                        <p>PIP® also bought out and settled all European partnership interests by consolidating all
                            business in Europe within PIP France. They also reworked all partnerships for PIP Mexico and
                            Latin America, enabling them to enter the PIP Global Family.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2018_West-Chester-Acquisition.JPG" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2019</strong>
                            <span>/</span>
                        </div>
                        <p>That year, PIP® acquired West Chester Protective Gear, a solidly established leader in Safety
                            with a strong business unit in the retail market. With this acquisition, PIP® became the
                            undisputed leader in work gloves. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2019_QRP_UT.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2019</strong>
                            <span>/</span>

                        </div>
                        <p>PIP’s acquisition strategy continued, but now, Joe and the management team set their eyes on
                            emerging markets. In 2019, PIP® purchased QRP®, a leader in hand protection for Controlled
                            Environments, followed by Uniform Technology®, a Colorado-based manufacturer of reusable
                            cleanroom garments. With the technological advancements being made in manufacturing, the
                            factories of tomorrow will be cleaner and more hi-tech. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2019_Dynamic.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2019</strong>
                            <span>/</span>
                        </div>
                        <p>PIP® also struck a deal to buy Dynamic Safety from Claude Roberge – a titan of the Safety
                            industry who started in the 1970s. After building then selling Arkon Safety, he came out of
                            retirement to build Dynamic Safety which became a leader in Canada as well as a global
                            manufacturer of hard hats, first aid and above-the-neck products.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/03_2019_WPP.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2019</strong>
                            <span>/</span>
                        </div>
                        <p>Worldwide Protective Products, a strong rival to PIP® in gloves and sleeves, also joined the
                            PIP Global Family during this time. As part of the Worldwide purchase, PIP® also acquired
                            U.S. Mesh, a leader in metal mesh protection for food processing. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/04_2019_Boss.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2019</strong>
                            <span>/</span>
                        </div>
                        <p>At the end of 2019, PIP® purchased Boss® Glove and Safety, a 100-year-old legacy brand in
                            work gloves as well as a leading source of boots and protective wear that is recognized
                            around the world.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/01_2020_PIP.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2020</strong>
                            <span>/</span>
                        </div>
                        <p>Today, PIP® is a $660 million entity with more than twenty-one locations around the world. A
                            flagship, state-of-the-art 800,000-square-foot distribution center was built in Olive
                            Branch, MS, to service most of the U.S. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/02_2020_PIP.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2020</strong>
                            <span>/</span>
                        </div>
                        <p>PIP® has seven manufacturing facilities in North America, ensuring that the supply of
                            critical PPE is available for American workers. We are proud of what we do and the industry
                            that we serve. </p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/04_2020_Caiman.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2020</strong>
                            <span>/</span>
                        </div>
                        <p>At the end of 2020, PIP® purchased Primax Manufacturing & Trading Inc. as well as the Caiman®
                            brand, a respected brand of high performance gloves and protective clothing for Welders,
                            Utility and Ranch workers. This acquisition significantly expanded PIP's existing welding
                            PPE and high performance glove offering to provide expanded value to distributors.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/05_2020_Odyssey.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2020</strong>
                            <span>/</span>
                        </div>
                        <p>In December of 2020, PIP® was acquired by Odyssey Investment Partners – another private equity
                            partner
                            with big plans for ushering in a new era of growth for the company. All members of the Milot and Tao
                            families,
                            as well as members of the senior management team, remain committed and invested in PIP’s future
                            growth.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/05_2021_Paramount.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2021</strong>
                            <span>/</span>
                        </div>
                        <p>On June 30, 2021, PIP® acquired Paramount Safety Products, the leading supplier of industrial safety
                            products across a wide range of industries in the Oceania Region, who also share in PIP’s family
                            roots. This addition to the PIP Global Family was key in advancing PIP’s objective to serve
                            customers around the globe while providing them with more opportunities for growth.</p>
                    </div>
                    <div class="item">
                        <figure>
                            <img src="/images/timeline/05_2022_Bisely.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2021</strong>
                            <span>/</span>
                        </div>
                        <p>At the end of 2021, PIP® acquired Bisley Workwear (“Bisley”), the top provider of workwear and
                            safetywear in the Oceania region. Bisley is headquartered outside of Sydney, Australia and is widely
                            recognized for its innovative workwear designs as well as for its ethical and sustainable sourcing
                            affiliations. This addition to the PIP Global family further advanced PIP's key objective of serving
                            customers globally by continually providing them with more opportunities for growth.</p>
                    </div>
                    <div class="item" id="last-slider">
                        <figure>
                            <img src="/images/timeline/sede-industrial-starter-italia.jpg" alt="timeline">
                        </figure>
                        <div class="year">
                            <strong>2022</strong>
                            <span>/</span>
                        </div>
                        <p>On June 8, 2022, PIP® acquired Industrial Starter, S.p.A, widely known in Europe as a quality
                            provider of PPE, workwear, footwear and fall protection – selling principally under the ISSALINE®
                            and Akrobat® brands. This union enables PIP® to significantly expand our operations in southern and
                            eastern Europe by adding strong people and a solid infrastructure that includes more than 215,000
                            sq. ft. (20,000 sq. mt.) of warehouse space.</p>
                    </div>
                </VueSlickCarousel>

                <section id="wrapper-literature" style="padding:0;">
                    <h3 class="space">PIP® Corporate Brochure</h3>
                    <ul class="docs" id="flip-book-literature">
                        <li>
                            <a class="show-popup" id="fh9s493pr" href="javascript:void(0);"><img
                                    src="/docs/Literature/images/PIP-Corporate-Brochure-042021-AP-Thumbnail.png"
                                    alt="coroporate brochure" /></a><br>
                            <a href="/docs/Literature/PIP-Corporate-Brochure-042021-AP.pdf" target="_blank"
                                class="btn-round-red pt9rem">DOWNLOAD/PRINT </a>
                        </li>
                        <li>
                            <a class="show-popup" id="vcm0hucbdc" href="javascript:void(0);"><img
                                    src="/docs/Literature/images/PIP-Close-To-Home-Manufacturing-Brochure-JA-04262020-AP-Thumbnail.png"
                                    alt="coroporate brochure" /></a><br>
                            <a href="/docs/Literature/PIP-Close-To-Home-Manufacturing-Brochure-JA-04262020-AP.pdf"
                                target="_blank" class="btn-round-red pt9rem">DOWNLOAD/PRINT </a>
                        </li>
                    </ul>
                </section>
                
                <div id="pip-corporate">
                    <section>
                        <h3 class="space">PIP® Corporate Video</h3>
                        <iframe height="260" width="380" src="https://www.youtube.com/embed/pszzs6UQo4U" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </section>
                    <section>
                        <h3 class="space">PIP® Corporate Video (Incl. History of Company)</h3>
                        <iframe height="260" width="380" src="https://www.youtube.com/embed/xJiK938wUe4" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </section>
                </div>
            </div><!-- .main-wrapper -->
        </div>
    <!-- </div> -->
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
    data() {
        return {
            settings: {
                "draggable": true,
                "infinite": false,
                "lazyLoad": "progressive",
                "slidesToShow": 1,
                "arrows": true,
                "speed": 100
            }
        }
    },
    components: { VueSlickCarousel }
};
</script>